export type TeachingEvaluationStatus = 'draft' | 'scheduled' | 'active' | 'completed';

export type TeachingEvaluationFormat = 'module' | 'teacher' | 'moduleAndTeacher';

export type TeachingEvaluationVotingMode = 'general' | 'byGroups' | 'custom';

export const LMS_VOTE_FORMAT = {
    teacher: 0,
    module: 1,
    moduleAndTeacher: 2,
} as const;

export const LMS_VOTE_TYPE = {
    general: 0,
    byGroups: 1,
    custom: 2,
} as const;

export const formatToLmsVoteFormatType = (
    format: TeachingEvaluationFormat,
): 0 | 1 | 2 => LMS_VOTE_FORMAT[format];

const normalizeEnumKey = (value: unknown) =>
    String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[_\s-]/g, '');

export const lmsVoteFormatTypeToFormat = (value: unknown): TeachingEvaluationFormat => {
    const key = normalizeEnumKey(value);
    if (key === 'teacher' || key === '0') return 'teacher';
    if (key === 'teachercourse' || key === 'moduleandteacher' || key === '2') {
        return 'moduleAndTeacher';
    }
    if (key === 'course' || key === 'module' || key === '1') return 'module';
    const n = typeof value === 'number' ? value : Number(value);
    if (n === 0) return 'teacher';
    if (n === 2) return 'moduleAndTeacher';
    return 'module';
};

export const votingModeToLmsVoteType = (
    mode: TeachingEvaluationVotingMode,
): 0 | 1 | 2 => LMS_VOTE_TYPE[mode];

export const lmsVoteTypeToVotingMode = (value: unknown): TeachingEvaluationVotingMode => {
    const key = normalizeEnumKey(value);
    if (key === 'bygroups' || key === '1') return 'byGroups';
    if (key === 'custom' || key === '2') return 'custom';
    if (key === 'general' || key === '0') return 'general';
    const n = typeof value === 'number' ? value : Number(value);
    if (n === 1) return 'byGroups';
    if (n === 2) return 'custom';
    return 'general';
};

export interface TeachingEvaluationCustomVoteGroup {
    groupId: string;
    teacherIds: string[];
}

export interface TeachingEvaluationLmsNamed {
    id: string;
    name: unknown;
}

export interface TeachingEvaluationLmsModule extends TeachingEvaluationLmsNamed {
    groups: TeachingEvaluationLmsNamed[];
}

export interface TeachingEvaluationLmsInfo {
    courseId: string;
    courseName: unknown;
    modules: TeachingEvaluationLmsModule[];
}

export interface TeachingEvaluationCampaign {
    id: string;
    teamId: string;
    name: string;
    moduleId: string;
    moduleName: string;
    moduleIds?: string[];
    format: TeachingEvaluationFormat;
    votingMode: TeachingEvaluationVotingMode;
    groupIds: string[];
    customVoteGroups: TeachingEvaluationCustomVoteGroup[];
    teacherIds: string[];
    teacherNames: string[];
    teacherAvatarUrls?: string[];
    openAt: string;
    closeAt: string;
    status: TeachingEvaluationStatus;
    createdAt: string;
    updatedAt: string;
    lmsInfo?: TeachingEvaluationLmsInfo;
}

export type TeachingEvaluationCampaignInput = Omit<
    TeachingEvaluationCampaign,
    'id' | 'createdAt' | 'updatedAt' | 'status'
> & {
    status?: TeachingEvaluationStatus;
};

export interface TeachingEvaluationCompletedKey {
    campaignId: string;
    accountId: string;
}

export const TEACHING_EVALUATION_AI = {
    campaignId: 'teaching_evaluation_campaignId',
    moduleName: 'teaching_evaluation_moduleName',
    closeAt: 'teaching_evaluation_closeAt',
    teamId: 'teaching_evaluation_teamId',
    courseUrl: 'teaching_evaluation_courseUrl',
    format: 'teaching_evaluation_format',
    teachers: 'teaching_evaluation_teachers',
} as const;

export const TEACHING_EVALUATION_GATE_STYLE = 'sop';
export const TEACHING_EVALUATION_GATE_STYLE_LEGACY = 'teaching_evaluation_gate';
export type TeachingEvaluationStatus = 'draft' | 'scheduled' | 'active' | 'completed';

export type TeachingEvaluationFormat = 'module' | 'teacher' | 'moduleAndTeacher';

export type TeachingEvaluationVotingMode = 'general' | 'byGroups' | 'custom';

export const LMS_VOTE_FORMAT = {
    teacher: 0,
    module: 1,
    moduleAndTeacher: 2,
} as const;

export const LMS_VOTE_TYPE = {
    general: 0,
    byGroups: 1,
    custom: 2,
} as const;

export const formatToLmsVoteFormatType = (
    format: TeachingEvaluationFormat,
): 0 | 1 | 2 => LMS_VOTE_FORMAT[format];

const normalizeEnumKey = (value: unknown) =>
    String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[_\s-]/g, '');

export const lmsVoteFormatTypeToFormat = (value: unknown): TeachingEvaluationFormat => {
    const key = normalizeEnumKey(value);
    if (key === 'teacher' || key === '0') return 'teacher';
    if (key === 'teachercourse' || key === 'moduleandteacher' || key === '2') {
        return 'moduleAndTeacher';
    }
    if (key === 'course' || key === 'module' || key === '1') return 'module';
    const n = typeof value === 'number' ? value : Number(value);
    if (n === 0) return 'teacher';
    if (n === 2) return 'moduleAndTeacher';
    return 'module';
};

export const votingModeToLmsVoteType = (
    mode: TeachingEvaluationVotingMode,
): 0 | 1 | 2 => LMS_VOTE_TYPE[mode];

export const lmsVoteTypeToVotingMode = (value: unknown): TeachingEvaluationVotingMode => {
    const key = normalizeEnumKey(value);
    if (key === 'bygroups' || key === '1') return 'byGroups';
    if (key === 'custom' || key === '2') return 'custom';
    if (key === 'general' || key === '0') return 'general';
    const n = typeof value === 'number' ? value : Number(value);
    if (n === 1) return 'byGroups';
    if (n === 2) return 'custom';
    return 'general';
};

export interface TeachingEvaluationCustomVoteGroup {
    groupId: string;
    teacherIds: string[];
}

export interface TeachingEvaluationLmsNamed {
    id: string;
    name: unknown;
}

export interface TeachingEvaluationLmsModule extends TeachingEvaluationLmsNamed {
    groups: TeachingEvaluationLmsNamed[];
}

export interface TeachingEvaluationLmsInfo {
    courseId: string;
    courseName: unknown;
    modules: TeachingEvaluationLmsModule[];
}

export interface TeachingEvaluationCampaign {
    id: string;
    teamId: string;
    name: string;
    moduleId: string;
    moduleName: string;
    moduleIds?: string[];
    format: TeachingEvaluationFormat;
    votingMode: TeachingEvaluationVotingMode;
    groupIds: string[];
    customVoteGroups: TeachingEvaluationCustomVoteGroup[];
    teacherIds: string[];
    teacherNames: string[];
    teacherAvatarUrls?: string[];
    openAt: string;
    closeAt: string;
    status: TeachingEvaluationStatus;
    createdAt: string;
    updatedAt: string;
    lmsInfo?: TeachingEvaluationLmsInfo;
}

export type TeachingEvaluationCampaignInput = Omit<
    TeachingEvaluationCampaign,
    'id' | 'createdAt' | 'updatedAt' | 'status'
> & {
    status?: TeachingEvaluationStatus;
};

export interface TeachingEvaluationCompletedKey {
    campaignId: string;
    accountId: string;
}

export const TEACHING_EVALUATION_AI = {
    campaignId: 'teaching_evaluation_campaignId',
    moduleName: 'teaching_evaluation_moduleName',
    closeAt: 'teaching_evaluation_closeAt',
    teamId: 'teaching_evaluation_teamId',
    courseUrl: 'teaching_evaluation_courseUrl',
    format: 'teaching_evaluation_format',
    teachers: 'teaching_evaluation_teachers',
} as const;

export const TEACHING_EVALUATION_GATE_STYLE = 'sop';
export const TEACHING_EVALUATION_GATE_STYLE_LEGACY = 'teaching_evaluation_gate';
